import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { fetchPublicLists } from '@terminal/services/watchlist/watchlist';

export const QUERY_KEY_PUBLIC_LISTS = 'QUERY_KEY_PUBLIC_LISTS';

export const usePublicLists = () =>
  useQuery({
    queryKey: [QUERY_KEY_PUBLIC_LISTS],
    queryFn: fetchPublicLists,
    staleTime: getTimeTillEndOfDayMs(),
  });
